import { ApiError } from "../api/client";

export function errorMessage(
  err: unknown,
  fallback = "Something went wrong. Please try again.",
): string {
  if (err instanceof ApiError) {
    if (
      err.code === "validation_error" &&
      Array.isArray(err.details) &&
      err.details.length
    ) {
      const first = err.details[0] as { msg?: string };
      if (first?.msg) return first.msg.replace(/^Value error, /, "");
    }
    return err.message || fallback;
  }
  return fallback;
}
